import { Suspense } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { Loading } from '~/components/composites/loading'
import { PortalLayout } from './layouts/portal'
import { HomePage } from './pages/home'
import { LoginPage } from './pages/login'
import { NgWordsPage } from './pages/ng-words'
import { SchoolsPage } from './pages/schools'
import { SkillsPage } from './pages/skills'
import { UsersPage } from './pages/users'
import { ReferralsPage } from './pages/referrals'
import { ReferralDetailPage } from './pages/referrals/detail'

export function App() {
  return (
    <Suspense fallback={<Loading />}>
      <PortalLayout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/ng-words" element={<NgWordsPage />} />
          {/* HER-311: Category Applications, Category Requests, and Service
              Packages admin pages are disabled at nakamoto's request (service
              packages are managed via Apple/Google IAP). Routes removed so the
              catch-all below redirects any bookmarked/deep link to home; page
              components are kept on disk for easy re-enable. */}
          <Route path="/skills" element={<SkillsPage />} />
          <Route path="/schools" element={<SchoolsPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/referrals" element={<ReferralsPage />} />
          <Route path="/referrals/:referrerId" element={<ReferralDetailPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </PortalLayout>
    </Suspense>
  )
}
